
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1189:306)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34.111 20.55h1.778l-2.667 3.15-2.666-3.15h1.777v-3.6h1.778v3.6zm-5.333-5.4H27L29.667 12l2.666 3.15h-1.777v3.6h-1.778v-3.6zM27 32.333v-6.666H14v6.666c0 .177.069.347.19.472a.642.642 0 00.46.195h11.7c.172 0 .338-.07.46-.195a.675.675 0 00.19-.472zm-13-8h13v-2.666a.675.675 0 00-.19-.472.642.642 0 00-.46-.195h-11.7a.642.642 0 00-.46.195.675.675 0 00-.19.472v2.666zM22.45 31v-1.333h2.6V31h-2.6z","fill":"#8200FF"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1189:306","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1189:306"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1189:306","result":"shape"}})])])])
          )
        }
      }
    